import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { bffBaseUrl } from "../constants/url-constants";

const BASE_API_URL = bffBaseUrl();

export default createScopedApi(BASE_API_URL, axiosInstance);
